module.exports = __webpack_public_path__ + "img/tra_bg_zeb@2x.fb0c8aa9.png";